import { gql, useMutation } from '@apollo/client';

import { GET_ALL_PLATFORM_JOBS } from './get-all-platform-jobs.hook';
import { GET_COMPANIES_WITH_JOBS } from './get-companies-with-jobs.hook';
import { GET_JOB_BY_ID } from './get-job-by-id.hook';
import { GET_JOB_LOCATIONS_BY_DEPARTMENT } from './get-job-locations-by-department.hook';

export const UPSERT_JOB = gql`
  mutation upsertJob($payload: UpsertJobInput!) {
    upsertJob(payload: $payload) {
      _id
    }
  }
`;

export const useUpsertJob = () => {
  const [upsertJob] = useMutation(UPSERT_JOB, {
    refetchQueries: [
      GET_COMPANIES_WITH_JOBS,
      GET_JOB_BY_ID,
      GET_ALL_PLATFORM_JOBS,
      GET_JOB_LOCATIONS_BY_DEPARTMENT,
    ],
  });

  return upsertJob;
};
